export default { sha: '3dbb047b8b9b697c0cad2b1153652b46939080a9', buildNumber: 'undefined' }
